<script lang="ts">
// noinspection JSUnusedGlobalSymbols

import type { FeatureLike } from 'ol/Feature'
import type { Style } from 'ol/style'
import { VectorLayerService } from '@nuxtDatakodeUtils/services/vectorLayer.service'

export default {
    name: 'GenericLayerStyle',
    components: {},
    props: {
        vectorLayerService: {
            type: VectorLayerService,
            required: true,
        },
        isEdit: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: [],
    data() {
        return {}
    },
    computed: {},

    mounted() {
        this.vectorLayerService.loadFontSymbolDefs()
    },

    methods: {
        getFeatureStyle(feature: FeatureLike, currentStyle: Style, resolution: number): Style {
            if (this.isEdit) {
                return this.vectorLayerService.getEditedFeatureStyle(feature, currentStyle, resolution)
            }
            return this.vectorLayerService.getFeatureStyle(feature, currentStyle, resolution)
        },
    },

}
</script>

<template>
    <ol-style :override-style-function="getFeatureStyle" />
</template>
